import { useGLTF } from "@react-three/drei"
import { useFrame, useThree } from "@react-three/fiber"
import { useEffect, useRef } from "react"

const Satellite = ({
  cameraControlRef,
  selectedSatellite,
  allSatelites,
  showSelect,
}) => {
  const satelliteModel = useGLTF([
    "/models/satellite3.glb",
    "/models/satellite3.glb",
    "/models/satellite3.glb",
    "/models/satellite3.glb",
  ])
  const mov1 = useRef(0)
  const satelliteRef1 = useRef()
  const groupRef1 = useRef()

  const mov2 = useRef(1500)
  const satelliteRef2 = useRef()
  const groupRef2 = useRef()

  const mov4 = useRef(3000)
  const satelliteRef3 = useRef()
  const groupRef3 = useRef()

  const mov5 = useRef(4500)
  const satelliteRef5 = useRef()
  const groupRef5 = useRef()

  useEffect(() => {
    if (selectedSatellite && !showSelect) {
      if (allSatelites.length === 1) {
        cameraControlRef.current.focusOnObject()
      } else {
        cameraControlRef.current.removePreviousObject()
        setTimeout(() => {
          cameraControlRef.current.focusOnObject()
        }, 1000)
      }
    } else {
      cameraControlRef.current.resetState()
    }
  }, [selectedSatellite])

  useFrame(() => {
    if (!selectedSatellite && !showSelect) {
      mov1.current += 0.0035
      satelliteRef1.current.position.set(
        2 * Math.cos(mov1.current),
        0,
        1.5 * Math.sin(mov1.current)
      )

      mov2.current += 0.0035
      satelliteRef2.current.position.set(
        2 * Math.cos(mov2.current),
        0,
        1.5 * Math.sin(mov2.current)
      )

      mov4.current += 0.0035
      satelliteRef3.current.position.set(
        2 * Math.cos(mov4.current),
        0,
        1.5 * Math.sin(mov4.current)
      )
      mov5.current += 0.0035
      satelliteRef5.current.position.set(
        2 * Math.cos(mov5.current),
        0,
        1.5 * Math.sin(mov5.current)
      )
    }
  })

  let position = showSelect ? [0.4, 1, 2.5] : [0, 0, 5]
  let rotation = showSelect ? [Math.PI / 12, 0, -12] : [Math.PI / 12, 0, 0]
  let rotationSatellite = showSelect ? [3.4, 0.4, 1.1] : [0, 0, 0]
  return (
    <>
      <group rotation={rotation} ref={groupRef1}>
        <group position={position} ref={satelliteRef1} name="satellite-model">
          <primitive
            object={satelliteModel[0].scene}
            rotation={rotationSatellite}
            scale={[0.1, 0.1, 0.1]}
          />
          <spotLight
            target={satelliteModel[0].scene}
            intensity={2}
            position={[12, -0.1, 0]}
            distance={0.3}
          />
          <spotLight
            target={satelliteModel[0].scene}
            intensity={2}
            position={[0, 0, -0.2]}
            distance={0.5}
          />
          <spotLight
            target={satelliteModel[0].scene}
            intensity={2}
            position={[0.2, 0.03, -0.1]}
            distance={0.35}
          />
        </group>
      </group>
      {!showSelect && (
        <group
          rotation={[Math.PI / 12, 0, 0]}
          ref={groupRef2}
          visible={!selectedSatellite}
        >
          <group position={[0, 0, 2]} ref={satelliteRef2}>
            <primitive
              object={satelliteModel[1].scene}
              scale={[0.1, 0.1, 0.1]}
            />
            <spotLight
              target={satelliteModel[1].scene}
              intensity={2}
              position={[0, -0.1, 0]}
              distance={0.3}
            />
            <spotLight
              target={satelliteModel[1].scene}
              intensity={2}
              position={[0, 0, -0.2]}
              distance={0.5}
            />
            <spotLight
              target={satelliteModel[1].scene}
              intensity={2}
              position={[0.2, 0.03, -0.1]}
              distance={0.35}
            />
          </group>
        </group>
      )}

      {!showSelect && (
        <group
          rotation={[Math.PI / 12, 0, 0]}
          ref={groupRef3}
          visible={!selectedSatellite}
        >
          <group position={[0, -Math.PI / 12, 2]} ref={satelliteRef3}>
            <primitive
              object={satelliteModel[2].scene}
              scale={[0.1, 0.1, 0.1]}
            />
            <spotLight
              target={satelliteModel[2].scene}
              intensity={2}
              position={[0, -0.1, 0]}
              distance={0.3}
            />
            <spotLight
              target={satelliteModel[2].scene}
              intensity={2}
              position={[0, 0, -0.2]}
              distance={0.5}
            />
            <spotLight
              target={satelliteModel[2].scene}
              intensity={2}
              position={[0.2, 0.03, -0.1]}
              distance={0.35}
            />
          </group>
        </group>
      )}
      {!showSelect && (
        <group
          rotation={[Math.PI / 12, 0, 0]}
          ref={groupRef5}
          visible={!selectedSatellite}
        >
          <group position={[0, -Math.PI / 12, 2]} ref={satelliteRef5}>
            <primitive
              object={satelliteModel[3].scene}
              scale={[0.1, 0.1, 0.1]}
            />
            <spotLight
              target={satelliteModel[3].scene}
              intensity={2}
              position={[0, -0.1, 0]}
              distance={0.3}
            />
            <spotLight
              target={satelliteModel[3].scene}
              intensity={2}
              position={[0, 0, -0.2]}
              distance={0.5}
            />
            <spotLight
              target={satelliteModel[3].scene}
              intensity={2}
              position={[0.2, 0.03, -0.1]}
              distance={0.35}
            />
          </group>
        </group>
      )}
    </>
  )
}
export default Satellite
